"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchPlacement = void 0;
var SearchPlacement;
(function (SearchPlacement) {
    SearchPlacement["Search"] = "search";
})(SearchPlacement = exports.SearchPlacement || (exports.SearchPlacement = {}));
